enum ReducerSliceNames{
    WALLET_INFO = "WalletInfo",
    POPUP = "Popup"
}

export default ReducerSliceNames;